export const en = {
  // Header
  header: {
    title: "R. M. Varaskar",
    subtitle: "Tax Consultant & Certified Auditor",
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      blog: "Blog",
      contact: "Contact"
    },
    cta: "Get In Touch"
  },

  // Hero Section
  hero: {
    badge: "Certified Professional Services",
    title: "Your Trusted Partner in",
    titleHighlight: "Tax & Audit Services",
    description: "Providing comprehensive tax consulting, auditing, and financial services with integrity and expertise.",
    location: "Serving All Over Maharashtra",
    ctaPrimary: "Schedule Consultation",
    ctaSecondary: "Explore Services",
    highlights: [
      { title: "Income Tax & GST", desc: "Expert tax consulting" },
      { title: "Society/Trust Audit", desc: "Comprehensive auditing" },
      { title: "Investment Advisory", desc: "Financial planning" }
    ]
  },

  // About Section
  about: {
    badge: "About Us",
    title: "Professional Excellence You Can Trust",
    description: "With a commitment to integrity and expertise, we provide comprehensive tax consulting, auditing and financial services that help businesses and individuals achieve financial security and compliance.",
    stats: [
      { label: "Years of Experience", value: "15+" },
      { label: "Clients Served", value: "10000+" },
      { label: "Successful Audits", value: "1000+" },
      { label: "Client Satisfaction", value: "99.9%" }
    ],
    whyChooseTitle: "Why Choose Us",
    whyChoose: [
      {
        title: "Professional Excellence",
        description: "Years of experience in tax consulting, auditing and financial services with proven track record."
      },
      {
        title: "Trust & Integrity",
        description: "Built on the foundation of honesty, transparency, and client-first approach in all dealings."
      },
      {
        title: "Local Expertise",
        description: "Deep understanding of Sindhudurg region's business landscape and compliance requirements."
      },
      {
        title: "Personalized Service",
        description: "Tailored solutions with computerized systems for efficient and accurate financial management."
      }
    ],
    certifiedTitle: "Certified & Licensed Professional",
    certifiedDesc: "All services are provided with the highest professional standards and compliance with regulatory requirements."
  },

  // Services Section
  services: {
    badge: "Our Services",
    title: "Comprehensive Professional Services",
    description: "From tax consulting to auditing, we offer a complete range of services designed to meet your business and personal financial needs.",
    services: [
      {
        title: "Income Tax & GST Consulting",
        description: "Expert guidance on income tax planning, GST compliance, and tax optimization strategies for individuals and businesses.",
        features: [
          "Income Tax Return Filing",
          "GST Registration & Returns",
          "Tax Planning & Advisory",
          "TDS Compliance & Returns"
        ]
      },
      {
        title: "Co-op Society / Trust Audit",
        description: "Comprehensive auditing services for cooperative societies and trusts, ensuring compliance and financial transparency.",
        features: [
          "Society Financial Audits",
          "Trust Compliance Review",
          "Statutory Reporting",
          "Internal Control Assessment"
        ]
      },
      {
        title: "Investment Advisory",
        description: "Professional guidance on investment planning and wealth management to help you achieve your financial goals.",
        features: [
          "Investment Planning",
          "Portfolio Management",
          "Mutual Fund Advisory",
          "Retirement Planning"
        ]
      },
      {
        title: "Computerized Accounts",
        description: "Modern accounting solutions with computerized bookkeeping and financial reporting for efficient business management.",
        features: [
          "Accounting Software Setup",
          "Bookkeeping Services",
          "Financial Report Generation",
          "Data Migration & Backup"
        ]
      },
      {
        title: "Passport Services",
        description: "Assistance with passport applications, renewals, and documentation to make the process smooth and hassle-free.",
        features: [
          "New Passport Applications",
          "Passport Renewals",
          "Documentation Assistance",
          "Application Tracking"
        ]
      },
      {
        title: "Company Auditing",
        description: "Professional auditing services for companies of all sizes, maintaining the highest standards of accuracy.",
        features: [
          "Annual Financial Audits",
          "Tax Audit Services",
          "Management Audit",
          "Due Diligence"
        ]
      }
    ],
    keyFeatures: "Key Features:",
    learnMore: "Learn More",
    ctaTitle: "Need a Custom Solution?",
    ctaDescription: "Every business is unique. Let's discuss how our services can be tailored to meet your specific requirements.",
    ctaButton: "Get a Free Consultation"
  },

  // Contact Section
  contact: {
    badge: "Get In Touch",
    title: "Let's Start a Conversation",
    description: "Whether you need tax consulting, auditing or investment advisory, we're here to help. Reach out today for a consultation.",
    infoTitle: "Contact Information",
    email: "Email",
    phone: "Phone",
    address: "Address",
    businessHours: "Business Hours",
    monday: "Monday - Friday:",
    saturday: "Saturday:",
    sunday: "Sunday:",
    closed: "Closed",
    formTitle: "Send a Message",
    formName: "Full Name",
    formNamePlaceholder: "Enter your name",
    formEmail: "Email Address",
    formEmailPlaceholder: "your.email@example.com",
    formPhone: "Phone Number",
    formPhonePlaceholder: "+91 XXXXX XXXXX",
    formMessage: "Message",
    formMessagePlaceholder: "Tell us about your requirements...",
    formSubmit: "Send Message",
    formSuccess: "Message Sent Successfully!",
    formSuccessDesc: "Thank you for reaching out. We'll get back to you shortly."
  },

  // Footer
  footer: {
    description: "Professional tax consulting, auditing and financial services with integrity and expertise.",
    quickLinks: "Quick Links",
    ourServices: "Our Services",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    allRightsReserved: "All rights reserved."
  },

  // Blog
  blog: {
    badge: "Blog & Insights",
    title: "Expert Insights on Auditing & Insurance",
    description: "Stay informed with the latest updates, tips, and best practices in auditing, insurance, and financial compliance.",
    categories: {
      all: "All",
      auditing: "Auditing",
      insurance: "Insurance",
      taxPlanning: "Tax Planning",
      taxCompliance: "Tax & Compliance"
    },
    readMore: "Read More",
    readTime: "min read",
    ctaTitle: "Need Professional Advice?",
    ctaDescription: "Our expertise goes beyond articles. Get personalized guidance for your specific needs.",
    ctaButton: "Schedule a Consultation",
    backToBlog: "Back to Blog",
    share: "Share",
    relatedArticles: "Related Articles",
    postCta: "Ready to Take Action?",
    postCtaDesc: "Get professional guidance tailored to your specific needs. Schedule a consultation today.",
    postCtaButton: "Get In Touch"
  },

  // Common
  common: {
    loading: "Loading...",
    error: "Something went wrong",
    retry: "Retry",
    required: "Required field"
  }
};
